import { makeStyles } from '@material-ui/core/styles';

export const useTextFieldQuestionFormStyles = makeStyles(theme => ({
  validationIconEnabled: {
    color: theme.palette.common.green400,
    '& path': {
      fill: theme.palette.common.green400,
    },
    '&:hover path': {
      fill: theme.palette.common.green400,
    },
  },
  validationIconButtonEnabled: {
    '&:hover path': {
      fill: theme.palette.common.green400,
    },
  },
  validationIconButton: {
    '&.Mui-disabled': {
      backgroundColor: 'transparent',
      opacity: 0.5,
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  header: {
    color: theme.palette.common.gray700,
    fontSize: '14px',
    fontWeight: 500,
  },
}));
